export interface PlaybookConfig {
  baseUrl: string;
}

export interface PlayConfig {
  /** module path */
  path: string;
  /** module unique */
  key: string;
  /** module url create from key */
  url: string;
}

const excludePath = [".", "..", "src", "packages"];

export class Playbook<L> {
  readonly list: PlayConfig[] = [];
  private map: Record<string, () => Promise<L>> = {};

  constructor(private config: PlaybookConfig) {}

  urlToKey(url: string) {
    if (url && url.startsWith(this.config.baseUrl)) {
      return url.substring(this.config.baseUrl.length);
    }
  }

  keyToUrl(module: string) {
    return this.config.baseUrl + module;
  }

  findModules(modules: Record<string, () => Promise<L>>) {
    Object.entries(modules).forEach(([path, module]) => {
      let parts = path.split("/");
      let filename = parts.pop();
      parts = parts.filter((part) => !excludePath.includes(part));
      filename = filename.split(".", 2)[0];
      parts.push(filename);
      const key = parts.join("/");

      if (this.map[key]) {
        console.warn("Duplicate module key skipped", key, path);
        return;
      }
      this.list.push({ key, path, url: this.keyToUrl(key) });
      this.map[key] = module;
    });
  }

  async loadModule(callback: () => void) {
    const module = this.urlToKey(document.location.pathname);

    if (!module) {
      console.warn("No module specified in url");
      callback();
      return;
    }

    console.log("Module specified in url", module);

    const loader = this.map[module];
    if (!loader) {
      console.error("Module not found", module);
      callback();
      return;
    }

    document.title = module;
    try {
      console.log("Module loading", module);

      await loader();
    } catch (error) {
      console.error("Failed to load module", module, error);
    }
    console.log("Initializing React app...");
    callback();
  }
}
